import React, { useEffect, useState, useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import {useDispatch, useSelector} from 'react-redux';

import SearchClientModal from '../common/Contract/SearchClientModal/SearchClientModal';
import CalculationOverview from '../common/Contract/CalculationOverview/CalculationOverview';
import { ContractForm } from '../common';
import { QUICK_CALCULATION_DATA } from '../../constants/localStorageConstants';
import { Message } from '../utilites';
import {permissionsAccess} from '../../helpers/common';
import {
  saveCalculations,
  notSaveCalculations, requestForCalculationFailed
} from '../../redux/actions/quickCalculationAction';

import './quick-calculation.scss';
import '../../assets/styles/components/_tables.scss';
import '../../assets/styles/components/_content-card.scss';
import '../../assets/styles/components/_content-tabs.scss';
import '../../assets/styles/components/_collapse.scss';
import '../../assets/styles/components/_dropdown.scss';

import ClearIcon from '../../assets/icons/clear.svg';
import {stateContractReset} from '../../redux/actions/contractAction';
import {messages} from "../../helpers/messages";
import Loader from "../Users/Loader/Loader";
import BasicAlert from "../utilites/Alert/Alert";

function QuickCalculation({setTitlePage}) {
  const [isClientModalOpen, setIsClientModalOpen] = useState(false);
  const [isClear, setIsClear] = useState(false);
  const [error, setError] = useState('');
  const [contextForm, setContextForm] = useState(null)
  const [contextCalculationLayout, setContextCalculationLayout] = useState(null)
  const { accessFeatures, isLoadingConfiguration } = useSelector(({user}) => user);
  const {
    commonError: calculationError} = useSelector(({quickCalculation}) => quickCalculation);
    const history = useHistory();
    const dispatch = useDispatch();

  useEffect(() => setIsClear(false), [isClear]);

  useEffect(() => {
    accessFeatures['title.header_section'] && setTitlePage('Быстрый расчёт');
      dispatch(stateContractReset());
  }, [isLoadingConfiguration]);

  const addNewClient = () => {
    history.push({ pathname: '/client', state: { isQuickCalculation: true } });
  };

  const handleSubmit = (data) => {
    history.push({
      pathname: `/client/${data.existingClient.value}/contract`,
      state: { isQuickCalculation: true },
    });
  };

  const handleCloseModal = () => {
    localStorage.removeItem(QUICK_CALCULATION_DATA);
    dispatch(notSaveCalculations())
    setIsClientModalOpen(false);
  };

  const onError = useCallback((error) => setError(error), []);

  const clearForm = () => {
    localStorage.removeItem(QUICK_CALCULATION_DATA);
    setIsClear(true);
  };

  const saveCalc = async () => {
    if (contextForm && contextCalculationLayout) {
      const resultContextForm = await contextForm.trigger()
      const resultContextCalculationLayout = await contextCalculationLayout.trigger()
      
      if (resultContextForm && resultContextCalculationLayout) {
        setIsClientModalOpen(true)
        dispatch(saveCalculations())
      } else {
        onError(messages[10])
      }
    } else {
      setIsClientModalOpen(true)
      dispatch(saveCalculations())
    }
  };

  const closeAlert = () => dispatch(requestForCalculationFailed(calculationError))

  return (
    <main className="app-content">
      { isLoadingConfiguration ?
        (<div className="content-inner">
            <Loader pageRange={1}/>
          </div>) :
        <>
          { !accessFeatures['title.header_section'] &&
            (<div className="content-header">
                <h1>Быстрый расчёт</h1>
              </div>
            )
          }
          <div className="content-inner">
            <div className="content-inner-data">
              <div className="content-inner-data-columns contract-flexContainer">
                <div className="content-inner-data-container contract-width">
                  {error && <Message type="error" text={error} />}
                  <div className="content-datatable">
                    <div className="content-datatable-header">
                      {permissionsAccess("calculations.quick.save") && (
                        <div className="content-datatable-header-left">
                          <div className="action-items">
                            <button className="action-item" onClick={saveCalc}>
                              Сохранить данные
                            </button>
                          </div>
                        </div>
                      )}
                      <div className="content-datatable-header-right">
                        <div className="action-items">
                          <button
                            className="button-icontrigger caption"
                            type="button"
                            onClick={clearForm}>
                        <span className="icon">
                          <ClearIcon />
                        </span>
                            <span>Очистить форму</span>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <ContractForm
                    contextCalculationLayout={contextCalculationLayout}
                    setContextCalculationLayout={setContextCalculationLayout}
                    setContextForm={setContextForm}
                    isClear={isClear}
                    onError={onError}
                  />
                </div>
                <CalculationOverview />
              </div>
            </div>
          </div>
        </>
      }
      <SearchClientModal
        isOpen={isClientModalOpen}
        handleModalSubmit={handleSubmit}
        handleCloseModal={handleCloseModal}
        addNewClient={addNewClient}
      />
      <BasicAlert onClose={() => closeAlert(false)}
                  message={calculationError}
                  isOpen={calculationError}
                  isError={true}/>
    </main>
  );
}

export default QuickCalculation;
